document.addEventListener("DOMContentLoaded", function () {
  window.MonogramState = window.MonogramState || {
    active: false,
    type: null,
    font: null,
    color: null,
    text: null,
    customerGroup: null,
    get() { return this.active ? { ...this } : null; },
    clear() { this.active = false; }
  };

  // const nextStep1 = document.getElementById("next-step-1");
  // const step2 = document.getElementById("step2");

  // nextStep1.addEventListener("click", () => {
  //   step2.style.display = "block";
  //   document.getElementById("step1").style.display = "none";
  // });

  // const nextStep2 = document.getElementById("next-step-2");
  // const step3 = document.getElementById("step3");

  // nextStep2.addEventListener("click", () => {
  //   step3.style.display = "block";
  //   document.getElementById("step2").style.display = "none";
  // });

  $(
    "<style type='text/css'>#closeMX:hover{cursor: pointer;}.msgMX{font-size:16px;}#boxMX{line-height:30px!important;text-align:center;display:none;background: white;padding: 10px;border: 1px solid darkgrey;float: left;position: fixed;top: 50%; left: 50%;z-index: 99999;box-shadow: 0px 0px 20px #999; -moz-box-shadow: 0px 0px 20px #999; -webkit-box-shadow: 0px 0px 20px #999; border-radius:6px 6px 6px 6px; -moz-border-radius: 6px; -webkit-border-radius: 6px; font:12px Raleway; padding:6px 6px 4px;width:344px; color: #3d3d3d;}</style>"
  ).appendTo("head");

  function alertMX(t) {
    $("body").append(
      $("<div id='boxMX'><p class='msgMX'></p><p id='closeMX'>CLOSE</p></div>")
    );
    $(".msgMX").text(t);
    var popMargTop = ($("#boxMX").height() + 24) / 2,
      popMargLeft = ($("#boxMX").width() + 24) / 2;
    $("#boxMX")
      .css({ "margin-top": -popMargTop, "margin-left": -popMargLeft })
      .fadeIn(200);
    $("#boxMX").click(function () {
      $(this).remove();
    });
  }

  const openPopupButton = document.getElementById("open-popup");
  const popupContainer = document.querySelector(".popup-container");

  const radioButtons = document.getElementsByName("option");
  const popup = document.getElementById("popup");

  for (let i = 0; i < radioButtons.length; i++) {
    radioButtons[i].addEventListener("change", function () {
      if (this.value === "yes") {
        popupContainer.style.display = "block";
        //  $("#Monogrammed").trigger("click");
      } else {
        $("#removeMonogram").trigger("click");
        popupContainer.style.display = "none";
      }
    });
  }

  // openPopupButton.addEventListener("click", function () {
  //   popupContainer.classList.add("active");
  // });

  const closePopupButton = document.querySelector(".close");
  closePopupButton.addEventListener("click", function () {
    popupContainer.style.display = "none";
    var colorName = $("#color_name").val();
    var fontName = $("#font_name").val();
    var monogramText = $("#monogram_text").val();
    if (colorName == "" && fontName == "") {
      $("#option2").prop("checked", true);
    }
    /////////////////// Scroll down ////////////////

    $("html, body").animate(
      {
        scrollTop: 0,
      },
      500
    );
    /////////////////// End Scroll down ////////////////
  });

  //////////////////////////////////////////////////////////////////
  // console.log('positiom->' position_data);

  arr1 = [];
  arr2 = [];
  arr3 = [];
  arr4 = [];
  arr5 = [];
  var arr = [];
  var json;
  var position;
  var position_x = "";
  var position_y = "";
  var font_size = "14px";

  var json = {
    Type: [
      {
        name: "Name",
        oldname: "monogram",
        Fonts: [
          {
            name: "Simple Script",
            image:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/SS.png",
            unique: "SS",
            max_length: "8",
            r_additional_charge: 17,
            w_additional_charge: 15,
          },
          {
            name: "Script Circle",
            image:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/SFC.png",
            unique: "SFC",
            max_length: "8",
            r_additional_charge: 17,
            w_additional_charge: 15,
          },
          {
            name: "Script Straight",
            image:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/SFS.png",
            unique: "SFS",
            max_length: "8",
            r_additional_charge: 17,
            w_additional_charge: 15,
          },
          {
            name: "Font Circle",
            image:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/FC.png",
            unique: "FC",
            max_length: "8",
            r_additional_charge: 17,
            w_additional_charge: 15,
          },
          {
            name: "Simple Block",
            image:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/SBF.png",
            unique: "SBF",
            max_length: "8",
            r_additional_charge: 17,
            w_additional_charge: 15,
          },
          {
            name: "Serif Block",
            image:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/SBF2.png",
            unique: "SBF2",
            max_length: "8",
            r_additional_charge: 17,
            w_additional_charge: 15,
          },
        ],
        Color: [
          {
            name: "Water Melon",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color1.jpg?v=1716546711",
            code: "#D84C89",
            unique: "MC1",
            r_additional_charge: 17,
            w_additional_charge: 15,
          },
          {
            name: "Red",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color2.jpg?v=1716546711",
            code: "#DB152C",
            unique: "MC2",
          },
          {
            name: "Hot Pink",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color3.jpg?v=1716546711",
            code: "#F52563",
            unique: "MC3",
          },
          {
            name: "Blush",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color4.jpg?v=1716546711",
            code: "#dfbfca",
            unique: "MC4",
          },
          {
            name: "Yellow Gold",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color6.jpg?v=1716546710",
            code: "#e4ce9d",
            unique: "MC5",
          },
          {
            name: "Light Camel",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color5.jpg?v=1716546711",
            code: "#f6f7f2",
            unique: "MC6",
          },
          {
            name: "Forest Green",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color7.jpg?v=1716546710",
            code: "#386348",
            unique: "MC7",
          },
          {
            name: "Mint Green",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color8.jpg?v=1716546711",
            code: "#49b971",
            unique: "MC8",
          },
          {
            name: "Robin Egg",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color9.jpg?v=1716546708",
            code: "#25a9be",
            unique: "MC9",
          },
          {
            name: "Silver Grey",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color10.jpg?v=1716546707",
            code: "#bebec0",
            unique: "MC10",
          },
          {
            name: "Black",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color11.jpg?v=1716546711",
            code: "#414048",
            unique: "MC11",
          },
          {
            name: "Blue",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color12.jpg?v=1716546711",
            code: "#484a85",
            unique: "MC12",
          },
          {
            name: "Coral",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color13.jpg?v=1716546710",
            code: "#ec756f",
            unique: "MC13",
          },
          {
            name: "Light Blue",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color14.jpg?v=1716546711",
            code: "#95aed6",
            unique: "MC14",
          },
        ],
      },
      {
        name: "Initials",
        oldname: "personalize",
        Fonts: [
          {
            name: "Simple Script",
            image:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/SS.png",
            unique: "SS",
            max_length: "3",
            r_additional_charge: 17,
            w_additional_charge: 15,
          },
          {
            name: "Script Circle",
            image:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/SFC.png",
            unique: "SFC",
            max_length: "3",
            r_additional_charge: 17,
            w_additional_charge: 15,
          },
          {
            name: "Script Straight",
            image:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/SFS.png",
            unique: "SFS",
            max_length: "3",
            r_additional_charge: 17,
            w_additional_charge: 15,
          },
          {
            name: "Font Circle",
            image:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/FC.png",
            unique: "FC",
            max_length: "3",
            r_additional_charge: 17,
            w_additional_charge: 15,
          },
          {
            name: "Simple Block",
            image:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/SBF.png",
            unique: "SBF",
            max_length: "3",
            r_additional_charge: 17,
            w_additional_charge: 15,
          },
          {
            name: "Serif Block",
            image:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/SBF2.png",
            unique: "SBF2",
            max_length: "3",
            r_additional_charge: 17,
            w_additional_charge: 15,
          },
          {
            name: "Floral Font",
            image:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/FF.png",
            unique: "FF",
            max_length: "1",
            r_additional_charge: 20,
            w_additional_charge: 18,
          },
        ],
        Color: [
          {
            name: "Water Melon",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color1.jpg?v=1716546711",
            code: "#D84C89",
            unique: "MC1",
          },
          {
            name: "Red",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color2.jpg?v=1716546711",
            code: "#DB152C",
            unique: "MC2",
          },
          {
            name: "Hot Pink",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color3.jpg?v=1716546711",
            code: "#F52563",
            unique: "MC3",
          },
          {
            name: "Blush",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color4.jpg?v=1716546711",
            code: "#dfbfca",
            unique: "MC4",
          },
          {
            name: "Yellow Gold",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color6.jpg?v=1716546710",
            code: "#e4ce9d",
            unique: "MC5",
          },
          {
            name: "Light Camel",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color5.jpg?v=1716546711",
            code: "#f6f7f2",
            unique: "MC6",
          },
          {
            name: "Forest Green",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color7.jpg?v=1716546710",
            code: "#386348",
            unique: "MC7",
          },
          {
            name: "Mint Green",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color8.jpg?v=1716546711",
            code: "#49b971",
            unique: "MC8",
          },
          {
            name: "Robin Egg",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color9.jpg?v=1716546708",
            code: "#25a9be",
            unique: "MC9",
          },
          {
            name: "Silver Grey",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color10.jpg?v=1716546707",
            code: "#bebec0",
            unique: "MC10",
          },
          {
            name: "Black",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color11.jpg?v=1716546711",
            code: "#414048",
            unique: "MC11",
          },
          {
            name: "Blue",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color12.jpg?v=1716546711",
            code: "#484a85",
            unique: "MC12",
          },
          {
            name: "Coral",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color13.jpg?v=1716546710",
            code: "#ec756f",
            unique: "MC13",
          },
          {
            name: "Light Blue",
            swatch:
              "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/color14.jpg?v=1716546711",
            code: "#95aed6",
            unique: "MC14",
          },
        ],
      },
    ],
  };
  //console.log(json);

  var regex = /[\"]/g;
  var customerGroup = document.getElementById("customer-group").value;
  var additional_charge = 17;
  console.log(customerGroup);
  for (var i = 0; i < json["Type"][0]["Fonts"].length; i++) {
    $("#fonts-li").append(
      '<li id="' +
        json["Type"][0]["Fonts"][i]["unique"] +
        '"  name="' +
        json["Type"][0]["Fonts"][i]["name"] +
        '" class="frontIdM"><img  style="width:50px;height:50px;"src="' +
        json["Type"][0]["Fonts"][i]["image"] +
        '"><p>' +
        json["Type"][0]["Fonts"][i]["name"] +
        "</p></li>"
    );
  }
  for (var i = 0; i < json["Type"][0]["Color"].length; i++) {
    $("#color-li").append(
      '<li id="' +
        json["Type"][0]["Color"][i]["unique"] +
        '" name="' +
        json["Type"][0]["Color"][i]["code"] +
        '" class="colorIdM" data-val="' +
        json["Type"][0]["Color"][i]["name"] +
        '"><img title="' +
        json["Type"][0]["Color"][i]["name"] +
        '" style="width:50px;height:50px;"src="' +
        json["Type"][0]["Color"][i]["swatch"] +
        '"><p>' +
        json["Type"][0]["Color"][i]["name"] +
        "</p></li>"
    );
  }
  var default_M_fonts_id = $("#fonts-li li:first").attr("id");
  arr3["selectedFont"] = default_M_fonts_id;
  // $("#" + default_M_fonts_id).addClass("active1");

  var default_M_color_id = $("#color-li li:first").attr("id");
  arr1["selectedColor"] = default_M_color_id;
  //  $("#" + default_M_color_id).addClass("active1");

  arr5["type"] = "Monogrammed";
  $("#Monogrammed").addClass("buttonclass");

  var default_family = $("#fonts-li li:first").attr("name");
  var default_color = $("#color-li li:first").attr("name");
  // arr["family"] = default_family;
  // arr["color"] = default_color;

  $(document).on("click", "#test", function () {
    //alert("hola");
    $("#Monogrammed").trigger("click");
  });

  $(document).on("click", ".frontIdM", function () {
    //$( ".frontIdM" ).click(function() {
    //  alert("Inside frontIdM");
    var id = jQuery(this).attr("name");
    var fntid = jQuery(this).attr("id");
    //  alert(fntid);

    $(".full-color").get(0).style.display = "block";

    var max_length = 8;
    //var additional_charge = 17;
    // alert(json["Type"].length);
    for (let i = 0; i < json["Type"].length; i++) {
      let obj = json["Type"][i];
      // alert(obj["oldname"] + ":" + arr["type"]);
      if (obj["name"] == arr["type"]) {
        let objFonts = json["Type"][i]["Fonts"];
        // alert(objFonts.lenth);
        for (let k = 0; k < objFonts.length; k++) {
          // alert(fntid + ":" + objFonts[k]["unique"]);
          if (fntid == objFonts[k]["unique"]) {
            max_length = objFonts[k]["max_length"];
            var customerGroup = document.getElementById("customer-group").value;
            if (customerGroup == "Approved")
              additional_charge = objFonts[k]["w_additional_charge"];
            else additional_charge = objFonts[k]["r_additional_charge"];
          }
        }
      }
    }

    $("#character").attr("maxlength", max_length);
    //$("#character").attr("placeholder", "upto " + max_length + " characters");
    $("#character").val("");
    $("span#chrCount").text(max_length);
    // var variable2 = arr["text"].substring(0, max_length);
    arr["text"] = max_length;
    arr["additional_charge"] = additional_charge;
    ////

    var selectedid = jQuery(this).attr("id");
    if ($.isEmptyObject(arr3)) {
      //console.log("inside if");
      arr3["selectedFont"] = selectedid;
      $("#" + selectedid).addClass("active1");
    } else {
      //console.log("inside else");

      $("#" + arr3["selectedFont"]).removeClass("active1");
      arr3["selectedFont"] = selectedid;
      $("#" + selectedid).addClass("active1");
    }
    ////
    // console.log(id);
    for (var z = 0; z < json["Type"][0]["Fonts"].length; z++) {
      if (json["Type"][0]["Fonts"][z]["family"] == id) {
        arr["link"] = json["Type"][0]["Fonts"][z]["link"];
      }
    }

    /////////////////// Scroll down ////////////////

    $(".upper_font-section").scrollTop($("div.step_three").offset().top);
    document.getElementById("color").scrollIntoView();

    /////////////////// End Scroll down ////////////////

    var ff = $("#character").val();
    arr["family"] = id;
    arr["text"] = ff;
    //arr['text']=ff;
    // render(arr);
    // console.log(arr);
  });

  $(document).on("click", ".frontId", function () {
    //$( ".frontId" ).click(function() {
    //  alert("frontId Clicked");
    var id = jQuery(this).attr("name");
    var fntid = jQuery(this).attr("id");
    $(".full-color").get(0).style.display = "block";

    var max_length = 8;
    // var additional_charge = 17;
    // alert(json["Type"].length);
    for (let i = 0; i < json["Type"].length; i++) {
      let obj = json["Type"][i];
      // alert(obj["oldname"] + ":" + arr["type"]);
      if (obj["name"] == arr["type"]) {
        let objFonts = json["Type"][i]["Fonts"];
        // alert(objFonts.lenth);
        for (let k = 0; k < objFonts.length; k++) {
          // alert(fntid + ":" + objFonts[k]["unique"]);
          if (fntid == objFonts[k]["unique"]) {
            max_length = objFonts[k]["max_length"];
            //additional_charge = objFonts[k]["additional_charge"];
            var customerGroup = document.getElementById("customer-group").value;
            if (customerGroup == "Approved")
              additional_charge = objFonts[k]["w_additional_charge"];
            else additional_charge = objFonts[k]["r_additional_charge"];
          }
        }
      }
    }

    $("#character").attr("maxlength", max_length);
    //$("#character").attr("placeholder", "upto " + max_length + " characters");
    $("span#chrCount").text(max_length);
    // var variable2 = arr["text"].substring(0, max_length);
    arr["text"] = max_length;
    arr["additional_charge"] = additional_charge;
    ////
    var selectedid = jQuery(this).attr("id");
    if ($.isEmptyObject(arr4)) {
      //console.log("inside if");
      arr4["selectedFont"] = selectedid;
      $("#" + selectedid).addClass("active1");
    } else {
      //console.log("inside else");

      $("#" + arr4["selectedFont"]).removeClass("active1");
      arr4["selectedFont"] = selectedid;
      $("#" + selectedid).addClass("active1");
    }
    ////
    for (var z = 0; z < json["Type"][1]["Fonts"].length; z++) {
      if (json["Type"][1]["Fonts"][z]["family"] == id) {
        arr["link"] = json["Type"][1]["Fonts"][z]["link"];
      }
    }
    /////////////////// Scroll down ////////////////

    $(".upper_font-section").scrollTop($("div#color"));
    document.getElementById("color").scrollIntoView();

    // alert("here");
    // $("div.step_three").animate(
    //   {
    //     scrollTop: 0,
    //   },
    //   500
    // );

    /////////////////// End Scroll down ////////////////
    $("#character").val("");
    var ff = $("#character").val();
    arr["family"] = id;
    arr["text"] = ff;
    //  render(arr);
    //  console.log(arr);
  });
  $(document).on("click", ".colorId", function () {
    //$( ".colorId" ).click(function() {
    //console.log("here");
    // alert("Color Selected");
    var id = jQuery(this).attr("name");
    var colorname = jQuery(this).attr("data-val");
    $(".mono_text").get(0).style.display = "block";
    ////
    var selectedid = jQuery(this).attr("id");
    if ($.isEmptyObject(arr2)) {
      // console.log("inside if");
      arr2["selectedColor"] = selectedid;
      $("#" + selectedid).addClass("active1");
    } else {
      //console.log("inside else");

      $("#" + arr2["selectedColor"]).removeClass("active1");
      arr2["selectedColor"] = selectedid;
      $("#" + selectedid).addClass("active1");
    }
    ////

    /////////////////// Scroll down ////////////////

    $(".upper_font-section").animate(
      {
        scrollTop: $("div.step_four").offset().top,
      },
      500
    );

    document.getElementById("character").scrollIntoView();
    /////////////////// End Scroll down ////////////////

    $("#texted").css("color", id);
    var ff = $("#character").val();
    arr["color"] = id;
    arr["colorname"] = colorname;
    arr["text"] = ff;
    // console.log(arr);
    //  render(arr);
  });

  $(document).on("click", ".colorIdM", function () {
    // alert("ColorIdM Selected");
    var id = jQuery(this).attr("name");
    var colorname = jQuery(this).attr("data-val");
    var selectedid = jQuery(this).attr("id");

    // $(".mono_text").style.display = "block";
    $(".mono_text").get(0).style.display = "block";
    if ($.isEmptyObject(arr1)) {
      //console.log("inside if");
      arr1["selectedColor"] = selectedid;
      $("#" + selectedid).addClass("active1");
    } else {
      $("#" + arr1["selectedColor"]).removeClass("active1");
      arr1["selectedColor"] = selectedid;
      $("#" + selectedid).addClass("active1");
    }
    //console.log("arr1",arr1);
    //  $("#texted").css("color", id);

    /////////////////// Scroll down ////////////////

    $(".upper_font-section").animate(
      {
        scrollTop: $("div.step_four").offset().top,
      },
      500
    );

    document.getElementById("character").scrollIntoView();
    /////////////////// End Scroll down ////////////////

    var ff = $("#character").val();
    arr["color"] = id;
    arr["colorname"] = colorname;
    arr["text"] = ff.substring(0, 3);
    // console.log(arr);
    // render(arr);
  });

  // $(".frontIdM").click(function () {
  //   $("#character").trigger("keyup");
  //   $(".upper_font-section").animate(
  //     {
  //       scrollTop: $("div.step_three").offset().top,
  //     },
  //     500
  //   );
  // });
  // $(".colorIdM").click(function () {
  //   $("#character").trigger("keyup");
  //   // $(".upper_font-section").animate(
  //   //   {
  //   //     scrollTop: $("div.step_four").offset().top,
  //   //   },
  //   //   500
  //   // );
  // });

  $("#character").keyup(function () {
    // console.log('array',arr);
    // $("#options_65_text").trigger("keyup");
    var ff = $("#character").val();
    //  $("#texted").html(ff);
    //  $("#" + textField).val(ff);
    //alert(arr["type"]);
    if (arr["type"] == "Name") {
      //  $("#error_msg").html('<span>1 or 2 characters</span>');
      var max_length = json["Type"][0]["max_length"];
      //var additional_charge = json["Type"][0]["additional_charge"];
      var customerGroup = document.getElementById("customer-group").value;
      if (customerGroup == "Approved")
        var additional_charge = json["Type"][0]["w_additional_charge"];
      else var additional_charge = json["Type"][0]["r_additional_charge"];
      var variable2 = ff.substring(0, max_length);
      arr["text"] = variable2;
    } else if (arr["type"] == "Initials") {
      //  $("#error_msg").html('<span>up to 9 characters</span>');
      var max_length = json["Type"][1]["max_length"];
      //var additional_charge = json["Type"][1]["additional_charge"];
      var customerGroup = document.getElementById("customer-group").value;
      if (customerGroup == "Approved")
        var additional_charge = json["Type"][1]["w_additional_charge"];
      else var additional_charge = json["Type"][1]["r_additional_charge"];
      var variable2 = ff.substring(0, max_length);
      arr["text"] = variable2;
    } else {
      var max_length = json["Type"][0]["max_length"];
      //var additional_charge = json["Type"][0]["additional_charge"];
      var customerGroup = document.getElementById("customer-group").value;
      if (customerGroup == "Approved")
        var additional_charge = json["Type"][0]["w_additional_charge"];
      else var additional_charge = json["Type"][0]["r_additional_charge"];
      var variable2 = ff.substring(0, max_length);
      arr["type"] = "Name";
      arr["text"] = variable2;
    }

    //arr['text']=ff;
    //  render(arr);
  });

  $(document).on("click", "#Monogrammed", function () {
    //alert("inside monogrammed clicked!!");
    // $("#error_msg").html('<span>upto 3 characters</span>');
    arr["type"] = "Name";
    if ($.isEmptyObject(arr5)) {
      arr5["type"] = "Monogrammed";
      $("#Monogrammed").addClass("buttonclass");
    } else {
      $("#" + arr5["type"]).removeClass("buttonclass");
      arr5["type"] = "Monogrammed";
      $("#Monogrammed").addClass("buttonclass");
    }

    $(".mono_text").get(0).style.display = "none";
    $("#character").val("");

    // render(arr);
    $("#fonts-li").empty();
    $("#color-li").empty();
    for (var i = 0; i < json["Type"][0]["Fonts"].length; i++) {
      $("#fonts-li").append(
        '<li id="' +
          json["Type"][0]["Fonts"][i]["unique"] +
          '" name="' +
          json["Type"][0]["Fonts"][i]["name"] +
          '" class="frontIdM"><img  style="width:50px;height:50px;"src="' +
          json["Type"][0]["Fonts"][i]["image"] +
          '"><p>' +
          json["Type"][0]["Fonts"][i]["name"] +
          "</p></li>"
      );
    }
    for (var i = 0; i < json["Type"][0]["Color"].length; i++) {
      $("#color-li").append(
        '<li id="' +
          json["Type"][0]["Color"][i]["unique"] +
          '" data-val="' +
          json["Type"][0]["Color"][i]["name"] +
          '" name="' +
          json["Type"][0]["Color"][i]["code"] +
          '" class="colorIdM"><img  style="width:50px;height:50px;"src="' +
          json["Type"][0]["Color"][i]["swatch"] +
          '"><p>' +
          json["Type"][0]["Color"][i]["name"] +
          "</p></li>"
      );
    }

    var default_M_fonts_id = $("#fonts-li li:first").attr("id");
    arr3["selectedFont"] = default_M_fonts_id;
    // $("#" + default_M_fonts_id).addClass("active1");

    var default_M_color_id = $("#color-li li:first").attr("id");
    arr1["selectedColor"] = default_M_color_id;
    //  $("#" + default_M_color_id).addClass("active1");

    arr5["type"] = "Monogrammed";
    $("#Monogrammed").addClass("buttonclass");

    var default_family = $("#fonts-li li:first").attr("name");
    var default_color = $("#color-li li:first").attr("name");
    // arr["family"] = default_family;
    // arr["color"] = default_color;
  });

  $(document).on("click", "#Personalized", function () {
    //$( "#Personalized" ).click(function() {
    // $("#error_msg").html("<span>up to 9 characters</span>");
    arr["type"] = "Initials";
    if ($.isEmptyObject(arr5)) {
      arr5["type"] = "Personalized";
      $("#Personalized").addClass("buttonclass");
    } else {
      $("#" + arr5["type"]).removeClass("buttonclass");
      arr5["type"] = "Personalized";
      $("#Personalized").addClass("buttonclass");
    }

    $(".mono_text").get(0).style.display = "none";
    $("#character").val("");
    // var max_length = json["Type"][1]["max_length"];
    // $("#character").attr("maxlength", max_length);
    $("#fonts-li").empty();
    $("#color-li").empty();
    for (var i = 0; i < json["Type"][1]["Fonts"].length; i++) {
      $("#fonts-li").append(
        '<li id="' +
          json["Type"][1]["Fonts"][i]["unique"] +
          '" name="' +
          json["Type"][1]["Fonts"][i]["name"] +
          '" class="frontId"><img  style="width:50px;height:50px;"src="' +
          json["Type"][1]["Fonts"][i]["image"] +
          '"><p>' +
          json["Type"][1]["Fonts"][i]["name"] +
          "</p></li>"
      );
    }
    for (var i = 0; i < json["Type"][1]["Color"].length; i++) {
      $("#color-li").append(
        '<li id="' +
          json["Type"][1]["Color"][i]["unique"] +
          '" data-val="' +
          json["Type"][1]["Color"][i]["name"] +
          '" name="' +
          json["Type"][1]["Color"][i]["code"] +
          '" class="colorId"><img  style="width:50px;height:50px;"src="' +
          json["Type"][1]["Color"][i]["swatch"] +
          '"><p>' +
          json["Type"][1]["Color"][i]["name"] +
          "</p></li>"
      );
    }
    arr["text"] = $("#character").val();
    var default_M_fonts_id = $("#fonts-li li:first").attr("id");
    arr4["selectedFont"] = default_M_fonts_id;
    //  $("#" + default_M_fonts_id).addClass("active1");

    var default_M_color_id = $("#color-li li:first").attr("id");
    arr2["selectedColor"] = default_M_color_id;
    //  $("#" + default_M_color_id).addClass("active1");

    arr5["type"] = "Personalized";
    $("#Personalized").addClass("buttonclass");

    var default_family = $("#fonts-li li:first").attr("name");
    var default_color = $("#color-li li:first").attr("name");
    // arr["family"] = default_family;
    // arr["color"] = default_color;
    // render(arr);
  });

  //////////////////////////////////////
  $(document).on("click", "#reset", function () {
    $("#fonts-li").val("");
    $("#color-li").val("");
    $("#character").val("");
    $(".full-color").get(0).style.display = "none";
    $(".mono_text").get(0).style.display = "none";
    $("#Monogrammed").prop("checked", true);
    arr = [];
    $("#" + arr1["selectedColor"]).removeClass("active1");
    $("#" + arr2["selectedColor"]).removeClass("active1");
    $("#" + arr3["selectedFont"]).removeClass("active1");
    $("#" + arr4["selectedFont"]).removeClass("active1");
    $("#" + arr5["type"]).removeClass("active1");

    $("#monogram_type").val("");
    $("#color_name").val("");
    $("#font_name").val("");
    $("#additional_charge").val("");
    $("#monogram_text").val("");
    $("#Monogrammed").trigger("click");
  });

  function getCheckedRadioValue(optionName) {
        var checkedValue = $('input[name="' + optionName + '"]:checked').val(); // Get the value of the checked radio button
        console.log("Checked " + optionName + ": " + checkedValue); // Log the value to the console
        return checkedValue !== undefined ? checkedValue : false; 
    }

  const addToCartButton = document.querySelector('.product-form__submit');
  const oldbuttonText = addToCartButton.querySelector('span').textContent.trim();
        
  
  $("#submit").click(function () {
    
    var submitForm = true;
    // alert(arr["family"]);
    if (typeof arr["type"] === "undefined" || arr["type"] == "") {
      submitForm = false;
      alertMX("Please select type");
      document.getElementById("Monogrammed").focus();
    } else if (typeof arr["family"] === "undefined" || arr["family"] == "") {
      submitForm = false;
      alertMX("Please select font");
      document.getElementById("fonts").focus();
    } else if (
      typeof arr["colorname"] === "undefined" ||
      arr["colorname"] == ""
    ) {
      submitForm = false;
      alertMX("Please select color");
      document.getElementById("color-li").focus();
    } else if ($("#character").val() == "") {
      submitForm = false;
      alertMX("Please enter text");
      document.getElementById("character").focus();
    }
    if (submitForm) {
    
      $("#monogram_type").val(arr["type"]);
      $("#color_name").val(arr["colorname"]);
      $("#font_name").val(arr["family"]);
      $("#monogram_text").val(arr["text"]);
      // if (isset(arr["additional_charge"]))
      if (typeof arr["additional_charge"] !== "undefined") {
        $("#additional_charge").val("$" + arr["additional_charge"]);
      }
      $("#final-data").get(0).style.display = "block";
      $("#final-data-buttons").get(0).style.display = "block";

      // Recompute the base variant fresh from whatever Size/PType is currently selected —
      // no fee-tier (C1/C2) suffix is ever appended; the fee is a separate line item added
      // via the Personalization Charges product, resolved by SKU in resolveFeeVariant().
      let baseVariantID = getNewVariantID();
      console.log('Base variantID: ' + baseVariantID);
      $(".product-variant-id").val(baseVariantID);

      var customerGroup = document.getElementById("customer-group").value;
      window.MonogramState.active = true;
      window.MonogramState.type = arr["type"];
      window.MonogramState.font = arr["family"];
      window.MonogramState.color = arr["colorname"];
      window.MonogramState.text = arr["text"];
      window.MonogramState.customerGroup = customerGroup;
      console.log('Monogram state set: ' + JSON.stringify(window.MonogramState.get()));

      alertMX(
        'Personalization saved successfully. Please "Add to cart" to proceed further.'
      );
      popupContainer.style.display = "none";

      /////////////// Code to display "Preorder" and "Preorder msg"///////////////

      const inventoryMessageElement = document.querySelector(
        ".product__inventory"
      );
      if (inventoryMessageElement) {
        inventoryMessageElement.style.display = "none";
      }

      const custominventoryMessageElement = document.querySelector(
        ".new_monogram_msg"
      );
      if (custominventoryMessageElement) {
        custominventoryMessageElement.style.display = "block";
        
      } else{
        console.log('---here---');
        const newElement = document.createElement('div');
        newElement.innerHTML = `
          <p class="product__inventory_new_monogram_msg no-js-hidden new_monogram_msg" id="new_monogram_msg" role="status" style="float: right;margin-top: 0px;">
              `+ oos_configuration_js.monogram.page_message +`
          </p>
        `;
       // alert(newElement.innerHTML);
        // Find the buy-section div
        const buySection = document.querySelector('.buy-section');
  
        // Check if the buy-section exists
        if (buySection) {
          console.log("Inside buy section");
          buySection.insertBefore(newElement, buySection.firstChild);
        }
      }

      const emailMessageInput = document.getElementById('emlMsg');
          if (emailMessageInput) {
            emailMessageInput.remove();
          }

      const newEmailMessageInput = document.createElement('input');
              newEmailMessageInput.type = 'hidden';
              newEmailMessageInput.id = 'emlMsg';
              newEmailMessageInput.name = 'properties[Note]';
              newEmailMessageInput.value = oos_configuration_js.monogram.email_message; 

      const productForm = document.querySelector("form[action='/cart/add'].form");
      if (productForm) {
        console.log("Inside productForm");
        productForm.appendChild(newEmailMessageInput);
        
      }


      if (addToCartButton) {
        // Change the text content of the button
          const buttonTextSpan = addToCartButton.querySelector('span');
          if (buttonTextSpan) {
              buttonTextSpan.textContent = oos_configuration_js.monogram.buy_button; // Change the text to "Out of stock"
          }
      } else {
          console.error("Add to cart button not found.");
      }

      

      ///////////////////////////////////////////////////////////////////////////
    }
  });

  function getNewVariantID(){
    let variants = window.productVariants; 
    console.log("Inside getNewVariantID" + JSON.stringify(variants));
      let newvariantID = null;
      var ptype = getCheckedRadioValue('PType');      
      var size = getCheckedRadioValue('Size');
    var color = getCheckedRadioValue('Color');
    // The fee is always a separate line item now (resolved by SKU in resolveFeeVariant()),
    // so this never appends a C1/C2 fee-tier suffix — newptype is just the base PType.
    let newptype = ptype;
      
      console.log('ptype ' + ptype + '|newptype:'+newptype);
        // Loop through the variants to find the matching one
        $.each(variants, function(index, variant) {
         // console.log('Looping ' + variant.option1);
          if(size != '' && color != ''){
            console.log("size and color not blank");
            if (variant.option1 === newptype && variant.option2 === size && variant.option3 === color) {
              console.log("ptype and size and color matched " + variant.id);
                newvariantID = variant.id; // Get the variant ID
               // break; // Break the loop
            }
          } else if(size != ''){
            console.log("size not blank");
            if (variant.option1 === newptype && variant.option2 === size) {
              console.log("ptype and size matched " + variant.id);
                newvariantID = variant.id; // Get the variant ID
               // break; // Break the loop
            }
          } else if(color != ''){
            console.log("color not blank");
            if (variant.option1 === newptype && variant.option2 === color) {
              console.log("ptype and color matched " + variant.id);
                newvariantID = variant.id; // Get the variant ID
               // break; // Break the loop
            }
          } else{
            if (variant.option1 === newptype) {
                newvariantID = variant.id; // Get the variant ID
               // break; // Break the loop
            }
          }
        });
    
    return newvariantID;
  }

  $(document).on("click", "#editMonogram", function () {
    var monogramType = $("#monogram_type").val();
    var colorName = $("#color_name").val();
    var fontName = $("#font_name").val();
    var monogramText = $("#monogram_text").val();
    // alert(fontName);
    // var fontElement = document.getElementsByName(fontName);
    // fontElement[0].addClass("active1");
    $('li[name="' + fontName + '"]').addClass("active1");

    $('li[data-val="' + colorName + '"]').addClass("active1");

    $("#character").val(monogramText);

    if (monogramType == "Initials") $("#Personalized").prop("checked", true);
    else if (monogramType == "Name") $("#Monogrammed").prop("checked", true);

    $(".full-color").get(0).style.display = "block";
    $(".mono_text").get(0).style.display = "block";

    popupContainer.style.display = "block";
    /////////////////// Scroll down ////////////////

    $(".upper_font-section").animate(
      {
        scrollTop: 0,
      },
      500
    );
    /////////////////// End Scroll down ////////////////
  });

  function resetMonogramUI() {
    // Resets both the visual "PERSONALIZE Yes / Type / Font..." panel and the underlying
    // state, so they can never drift apart (that drift was the root cause of a bug where
    // changing size/color and re-adding to cart without re-clicking Save silently skipped
    // the fee — MonogramState.active was already false, but the panel still looked active).
    $("#monogram_type").val("");
    $("#color_name").val("");
    $("#font_name").val("");
    $("#monogram_text").val("");
    $("#additional_charge").val("");
    $("#reset").trigger("click");
    $("#final-data-buttons").get(0).style.display = "none";
    $("#final-data").get(0).style.display = "none";
    $("#option2").prop("checked", true);

    window.MonogramState.clear();
  }
  window.resetMonogramUI = resetMonogramUI;

  $(document).on("click", "#removeMonogram", function () {
    resetMonogramUI();

    const radioButtons1 = $('input[name="option"]');
    radioButtons1.trigger("change");
    /////////////// Code to remove "Preorder" and "Preorder msg"///////////////


   
    
     const inventoryMessageElement = document.querySelector(
         ".product__inventory"
     );
    const textContent = inventoryMessageElement.textContent.trim();
    console.log("teext " + textContent);

      if (inventoryMessageElement) {
        console.log("Inside inventoryMessageElement");
        inventoryMessageElement.style.display = "block";
      }

    const custominventoryMessageElement = document.querySelector(
        ".new_monogram_msg"
      );
      if (custominventoryMessageElement) {
        custominventoryMessageElement.style.display = "none";
        
      }

    if(textContent!= oos_configuration_js.monogram.page_message.trim()){
          const emailMessageInput = document.getElementById('emlMsg');
          if (emailMessageInput) {
            emailMessageInput.remove();
          }
    }

    if (addToCartButton) {
        // Change the text content of the button
          const buttonTextSpan = addToCartButton.querySelector('span');
          if (buttonTextSpan) {
              buttonTextSpan.textContent = oldbuttonText; // Change the text to "Out of stock"
          }
      } else {
          console.error("Add to cart button not found.");
      }
    

    //////////////////////////////////////////////////////////////////////////
    // radioButtons.trigger("change");
    //popupContainer.style.display = "block";
  });

  /////////////// Check variant selection change /////////////////

  var variantRadios = document.querySelectorAll('input[name="Size"]'); 

    variantRadios.forEach(function(radio) {
        radio.addEventListener('change', function(event) {
            var selectedVariantValue = event.target.value; 
            console.log('Variant changed to:', selectedVariantValue);
            var radioButton = document.getElementById('option1'); 
  
            if (radioButton) {
                var isChecked = radioButton.checked; 
              if(isChecked){
                let variantID = getNewVariantID();
                console.log('variantID' + variantID);
      
                $(".product-variant-id").val(variantID);
                var productVariantID = $(".product-variant-id").val();
                console.log('productVariantID ' + productVariantID);
                // Never stopPropagation — the base variant we set here already matches what
                // Shopify's native picker would compute on its own, so let the event continue
                // so the native picker can update/clear its own "Cannot find variant" state.
              } else{
                  console.log('Not personalized item:');
              }
                
                
            } else {
                console.log('personalization button not found.');
            }
            
        });
    });

  //////////////////////////////////////////////////////////////////
});
